import { render, staticRenderFns } from "./afterSalesPolicy.vue?vue&type=template&id=7578b5f2&scoped=true"
import script from "./afterSalesPolicy.vue?vue&type=script&lang=js"
export * from "./afterSalesPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578b5f2",
  null
  
)

export default component.exports